import React from "react"
import BackgroundImages from "gatsby-background-image"

export default function BackgroundImage({ img, styleClass, title, children }) {
  return (
    <BackgroundImages className={styleClass} fluid={img}>
      <h1 className="title text-white text-uppercase text-center display-1 font-weight-bold">
        {title}
      </h1>
      {children}
    </BackgroundImages>
  )
}

BackgroundImage.defaultProps = {
  title: "default title",
  styleClass: "default-background",
}
